<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { scrollToSection } from "@/utils/functions";
import { useScrollSpy } from "@/composables/useScrollSpy";
import { useScrollStore } from "@/stores/storeScroll";
import { useSettingsStore } from "@/stores/storeSettings";

const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();

const links = { personalData: "Личные данные" , myPrizes: "Мои призы" , uploadedReceipts: "Загруженные чеки"};
const { activeId } = useScrollSpy(Object.keys(links));

const currentLink = ref('personalData');
const headerProfile = ref(null);
const activeBtn = ref(false);
const ignoreScrollSpy = ref(false);

const toggleLink = (value, key) => {
	ignoreScrollSpy.value = true;
	currentLink.value = key;
	scrollToSection(key);
	setTimeout(() => {
		ignoreScrollSpy.value = false;
	}, 500);
};
const showOptions = () => {
	activeBtn.value = !activeBtn.value;
};

watch(activeId, (newId) => {
	
	if (!ignoreScrollSpy.value && newId && links[newId]) {
		currentLink.value = newId;
	}
});

onMounted(() => {
	storeScroll.headerProfile = headerProfile.value;
});
</script>
<template>
	<div class="profile-links" ref="headerProfile" >
		<button v-for="(value, key, index) in links" :key="index" :class="['profile-btn btn --small',  currentLink === key ? '' : '--border-white' ]" @click="toggleLink(value, key, index)">
			{{ value }}  
		</button>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.profile-links {
	// width: 100%;
	display: flex;
	align-items: start;
	flex-direction: column;
	gap: .7rem;
	@media (max-width: vars.$mn) {
		flex-direction: row;
		flex-wrap: nowrap;
	}
	@media (max-width: vars.$x480) {
		gap: 1rem;
	}
}
.profile-btn {
	width: 100%;
	justify-content: start;
	@media (max-width: vars.$mn) {
		justify-content: center;
	}
	@media (max-width: vars.$x480) {
		min-height: 3.2rem;
		font-size: 1.6rem;
	}
}

</style>
